<template>
  <v-container>
    <v-row align="center">
      <v-col cols="auto">
        <v-icon color="primary">mdi-web</v-icon>
      </v-col>
      <v-col cols="auto">
        <v-select :value="lang" :items="items" @change="changeLocale"></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      items: [
        {
          text: this.$t('lang.zh-TW'),
          value: 'zh-TW'
        },
        {
          text: this.$t('lang.en'),
          value: 'en'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      lang: state => state.settings.lang
    })
  },
  methods: {
    ...mapActions({
      changeLocale: 'settings/changeLocale'
    })
  }
}
</script>
